module.exports = {
  login:'Masuk',
  taption: 'Taption',
  ways_to_use_taption:'Cara menggunakan Taption',
  faq:'FAQ',
  pricing:'Harga',
  language:'Bahasa',
  product:'Produk'
}
